module.exports = __webpack_public_path__ + "static/media/Matplotlib.2e8040ec.png";